import {
  WSCard,
  WSElement,
  WSFlexBox,
  WSList,
  WSPill,
  WSText
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";
import { useQueryInternalAccountBalance } from "../../../../query/banking/queries/useQueryInternalAccountBalance";
import { useQueryInternalAccounts } from "../../../../query/banking/queries/useQueryInternalAccounts";
import { useCardLimits } from "../../../../query/cards/queries/useCardLimits";
import {
  ICardResponse,
  IPaymentCardLimitType
} from "../../../../services/api/banking/cards/types";
import { selectorActiveBankingAccount } from "../../../../shared/selectors/selectorActiveBankingAccount";

export const CardBalance: React.FC<{ card: ICardResponse }> = ({ card }) => {
  const queryInternalAccounts = useQueryInternalAccounts();
  const internalAccount = queryInternalAccounts.data?.find(
    selectorActiveBankingAccount
  );
  const queryInternalAccountBalance = useQueryInternalAccountBalance(
    internalAccount?.internalAccountId!,
    {
      enabled: !!internalAccount?.internalAccountId
    }
  );

  const queryCardLimits = useCardLimits(card.cardId);

  const availableBalance = queryInternalAccountBalance.data?.available || 0;

  const limitType = queryCardLimits.data?.limitType || "Monthly";
  const limit = (queryCardLimits.data?.limitInCents || 0) / 100;
  const availableLimit =
    (queryCardLimits.data?.availableLimitInCents || 125000) / 100;
  const spendLimit = limit - availableLimit;

  const limitTexts: Record<IPaymentCardLimitType, string> = {
    Monthly: `of ${formatMoney(
      availableLimit,
      internalAccount?.currency || "USD"
    )} daily limit`,
    Forever: `of ${formatMoney(
      availableLimit,
      internalAccount?.currency || "USD"
    )} limit`,
    Annually: `of ${formatMoney(
      availableLimit,
      internalAccount?.currency || "USD"
    )} annual limit`,
    Transaction: `of ${formatMoney(
      availableLimit,
      internalAccount?.currency || "USD"
    )} transaction limit`
  };

  return (
    <WSCard>
      <WSList gap="XL">
        <WSElement>
          <WSText weight="medium" color="gray600">
            Available balance
          </WSText>
          <WSText.Heading1
            weight="book"
            color="gray500"
            shimmer={!queryInternalAccountBalance.isSuccess}
          >
            {formatMoney(availableBalance, internalAccount?.currency || "USD")}
          </WSText.Heading1>
        </WSElement>

        <WSList>
          <WSFlexBox.CenterY justify="space-between">
            <WSText.ParagraphSm color="gray500">
              Daily spend limit
            </WSText.ParagraphSm>

            <WSPill
              theme="neutral"
              text={formatMoney(
                availableLimit,
                internalAccount?.currency || "USD"
              )}
            />
          </WSFlexBox.CenterY>

          <WSFlexBox.CenterY justify="space-between">
            <WSText.ParagraphSm color="gray500">
              Monthly spend limit
            </WSText.ParagraphSm>

            <WSPill theme="neutral" text="$10,000.00" />
          </WSFlexBox.CenterY>
        </WSList>
      </WSList>
    </WSCard>
  );
};
